import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Input, InputAdornment, InputLabel, Stack, TextField, Typography } from "@mui/material";
import { Ico_Warning } from "@sagecentral/core-ui";
import { IProcessTimeOptions } from "models/tasks";
import { useState } from "react";

type ProcessTimeDialogProps = {
    open: boolean;
    working: boolean;
    onConfirm: (options: IProcessTimeOptions) => void;
    onCancel: () => void;
};

const ProcessTimeDialog = (props: ProcessTimeDialogProps) => {
    const { 
        open,
        working,
        onConfirm,
        onCancel
    } = props;

    const [ options, setOptions ] = useState<IProcessTimeOptions>({
        hours: 0,
        minutes: 0
    });

    const handleConfirm = () => {
        onConfirm(options);
    };

    const handleCancel = () => {
        setOptions({
            hours: 0,
            minutes: 0
        });
        onCancel();
    };

    const setHours = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = +event.target.value;
        if (Number.isInteger(value) && +value >= 0) {
            setOptions({
                ...options,
                hours: +value
            });
        }
    };
    
    const setMinutes = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = +event.target.value;
        if (Number.isInteger(value) && +value >= 0) {
            setOptions({
                ...options,
                minutes: +value
            });
        }
    };

    return (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle>
                <Stack direction='row' spacing={1} sx={{
                    alignItems: 'center'
                }}>
                    <Ico_Warning color='error' sx={{
                        height: '40px',
                        width: '40px'
                    }}/>
                    <span>Process Time</span>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Typography variant='body1' sx={{
                        fontWeight: 600
                    }}>
                        Please record how much time you spent working on this task (excluding interruptions).
                    </Typography>
                    <Stack spacing={1} direction='row'>
                        <TextField id='process-time-hours'
                            label='Hours'
                            variant='outlined'
                            value={options.hours}
                            onChange={setHours}
                        />
                        <TextField id='process-time-mins'
                            label='Minutes'
                            variant='outlined'
                            value={options.minutes}
                            onChange={setMinutes}
                        />
                    </Stack>
                    <Typography variant='caption' color='error'>
                        Please note that hours and minutes cannot add to zero
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button fullWidth 
                    variant="outlined" 
                    onClick={handleCancel} 
                    disabled={working}
                >
                    Cancel
                </Button>
                <Button fullWidth
                    variant='contained'
                    color='primary'
                    disabled={working}
                    endIcon={ working 
                        ? <CircularProgress 
                            size={20}
                            sx={{
                                position: 'unset',
                                color: (theme) => theme.palette.primary.contrastText
                            }}
                        /> 
                        : null
                    }
                    onClick={handleConfirm}
                >
                    Submit & Complete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProcessTimeDialog;